module.exports = __webpack_public_path__ + "img/expand2.5af81d40.svg";